import React, { useState } from "react";
import "./index.css";
import app_store from "../../assets/app_store.webp";
import play_store from "../../assets/play_store.webp";
import heroBackground from "../../assets/iStock-589448332.jpg";
import SearchBar from "../../component/common/icon-searchbar/IconSearchBar";
import {
  Box,
  Container,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import appInHand from "../../assets/app_phone_screenshot.png";
import CustomModal from "../../component/common/CustomModal/CustomModal";
import { RxCross2 } from "react-icons/rx";
import CustomQRCode from "../../component/common/CustomQRCode/CustomQRCode";
import { FaStar } from "react-icons/fa";
import { BsClock } from "react-icons/bs";
import { MdCheckCircle, MdWork } from "react-icons/md";
import plumbingImg from "../../assets/bento_plumber.png";
import certifiedProImg from "../../assets/certified_pro.png";

const HeroSection = () => {
  const navigate = useNavigate();
  const [isOpenQRModal, setIsOpenQRModal] = useState(false);

  return (
    <div>
      {/* Hero Section */}
      <div className="home-section">
        <img
          className="background-image"
          src={heroBackground}
          alt="Hero Background"
        />
        <div className="overlay"></div>
        <div className="content">
          <Stack direction="row" spacing={1.5} flexWrap="wrap" sx={{ rowGap: 1, mb: 2 }}>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1,
                backgroundColor: "rgba(255,255,255,0.15)",
                backdropFilter: "blur(10px)",
                padding: "8px 16px",
                borderRadius: "50px",
              }}
            >
              <FaStar size={12} color="#fbbf24" />
              <Typography sx={{ fontSize: "13px", fontWeight: "500" }}>
                4.8 ★★★★★ Trusted by homeowners across Canada
              </Typography>
            </Box>
          </Stack>
          <Typography
            fontWeight={"800"}
            sx={{
              fontSize: {
                xs: "32px",
                sm: "42px",
                md: "52px",
                lg: "62px",
              },
              lineHeight: 1.1,
              letterSpacing: "-0.03em",
            }}
          >
            Home care, handled.
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "15px", sm: "18px", md: "20px" },
              opacity: 0.85,
              mt: 1.5,
              maxWidth: "500px",
              px: { xs: 2, sm: 0 },
            }}
          >
            Trusted local pros for repairs, cleaning, and more.
          </Typography>
          <Box
            sx={{
              width: { xl: "38%", lg: "42%", md: "50%", sm: "70%", xs: "92%" },
              mt: { xs: 2.5, sm: 4 },
            }}
          >
            <SearchBar />
          </Box>

          {/* Trust indicators */}
        </div>
      </div>

      {/* Stats Bento Grid */}
      <Box sx={{ backgroundColor: "#ffffff", py: { xs: 4, sm: 8 }, px: { xs: 2, sm: 0 } }}>
        <Container maxWidth="lg">
          {/* Trust panel — navy band, stats woven as prose (intentionally unlike Jiffy's 3-col grid) */}
          <Box
            sx={{
              backgroundColor: "#1A1410",
              borderRadius: { xs: "16px", md: "20px" },
              py: { xs: 4, md: 6 },
              px: { xs: 3, md: 6 },
              my: { xs: 2, md: 4 },
              maxWidth: { xs: "100%", md: "780px" },
              mx: "auto",
            }}
          >
            <Typography
              sx={{
                color: "#FFFFFF",
                fontSize: { xs: "22px", sm: "28px", md: "34px" },
                fontWeight: 700,
                lineHeight: 1.35,
                letterSpacing: "-0.01em",
                textAlign: { xs: "left", md: "center" },
                maxWidth: "900px",
                mx: "auto",
              }}
            >
              <Box component="span" sx={{ color: "#F15A24" }}>
                2,500+ jobs completed
              </Box>
              {" "}— rated{" "}
              <Box component="span" sx={{ color: "#F15A24", whiteSpace: "nowrap" }}>
                4.8 <FaStar size={20} style={{ verticalAlign: "middle", marginTop: -4 }} />
              </Box>
              {" "}on the App Store, with{" "}
              <Box component="span" sx={{ color: "#F15A24" }}>
                96%
              </Box>
              {" "}of jobs done right the first time.
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Meet a Certified Pro Section */}
      <Box sx={{ backgroundColor: "#FFFFFF", py: { xs: 5, md: 8 }, px: { xs: 2, sm: 0 } }}>
        <Container maxWidth="lg">
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={{ xs: 3, md: 6 }}
            alignItems="center"
            justifyContent="center"
          >
            <Box
              component="img"
              src={certifiedProImg}
              alt="Certified Done Right Away pro"
              sx={{
                width: { xs: "160px", md: "200px" },
                height: { xs: "160px", md: "200px" },
                borderRadius: "50%",
                objectFit: "cover",
                boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
                flexShrink: 0,
              }}
            />
            <Stack
              spacing={1.5}
              sx={{
                textAlign: { xs: "center", md: "left" },
                alignItems: { xs: "center", md: "flex-start" },
                maxWidth: "560px",
              }}
            >
              <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}>
                <MdCheckCircle size={14} color="#F15A24" />
                <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#F15A24", letterSpacing: "0.02em" }}>
                  CERTIFIED PRO
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: { xs: "24px", md: "30px" },
                  fontWeight: 700,
                  color: "#0F2231",
                  lineHeight: 1.2,
                }}
              >
                Meet Marco, one of our certified pros
              </Typography>
              <Typography sx={{ fontSize: { xs: "14px", md: "15px" }, color: "#5A6772", lineHeight: 1.7 }}>
                Every job on Done Right Away goes to a background-checked, insured professional like Marco —
                8+ years in the trade, vetted before he ever accepts a job.
              </Typography>
              <Stack direction="row" alignItems="center" spacing={1} sx={{ pt: 0.5 }}>
                <BsClock size={16} color="#F15A24" />
                <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#F15A24" }}>
                  Average response time: under 5 minutes
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Container>
      </Box>

      {/* QR Modal */}
      <CustomModal isOpen={isOpenQRModal} setIsOpen={() => setIsOpenQRModal(false)}>
        <Stack
          alignItems="center"
          sx={{
            backgroundColor: "#fff",
            p: 4,
            borderRadius: "16px",
            width: { xs: "90%", sm: "360px" },
            margin: "auto",
          }}
          gap={3}
        >
          <IconButton
            sx={{ position: "absolute", top: 12, right: 12 }}
            onClick={() => setIsOpenQRModal(false)}
          >
            <RxCross2 />
          </IconButton>
          <Typography sx={{ fontSize: "18px", fontWeight: "600" }}>
            Scan to download
          </Typography>
          <CustomQRCode QR_size={180} QR_link={"https://donerightaway.com/coming-soon-app"} />
          <Typography sx={{ fontSize: "13px", color: "#666" }}>
            Point your camera at the QR code
          </Typography>
        </Stack>
      </CustomModal>
    </div>
  );
};

export default HeroSection;
